// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal.modal--banmodal{max-width:736px;padding-bottom:0}.ban-modal__body{padding:24px 0}.ban-modal__info-message{margin-bottom:24px}.ban-modal__text{font-weight:normal;font-size:16px;line-height:24px;color:#cfd8dc;margin-bottom:16px}.ban-modal__email-link{color:#fff;text-decoration:underline}.ban-modal__btn{margin-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
